import i18n from 'i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { getErrorMessageFromAPI } from '@/utilz';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import {
  type SendOCClaimPdfToCarrierRequestBody,
  sendOCClaimPdfToCarrierProvider,
} from '../../data-provider/over-charge-claim-emails';

export type SendOCClaimPdfToCarrierVariables = SendOCClaimPdfToCarrierRequestBody & {
  handleDone?: () => void;
};

export const useSendOCClaimPdfToCarrier = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ handleDone: _handleDone, ...payload }: SendOCClaimPdfToCarrierVariables) =>
      sendOCClaimPdfToCarrierProvider(payload),
    onError: (e: { response: any }) => {
      showNotification({
        message: getErrorMessageFromAPI(e, i18n.t('translation:default.fields.transportationProvider.emailError')),
        type: NOTIFICATION_TYPES.ERROR,
      });
    },
    onSuccess: (_data, variables) => {
      showNotification({
        message: i18n.t('translation:default.fields.transportationProvider.email'),
        type: NOTIFICATION_TYPES.SUCCESS,
      });
      variables.handleDone?.();
      queryClient.invalidateQueries({
        queryKey: ['claims-over-charge-email-notifications', variables.fbocKey],
      });
    },
  });
};
